import { useEffect, useState } from "react";

async function loadSupabaseClient() {
  const module = await import("../lib/supabase");
  return module.getSupabaseClient();
}

export default function AuthCallbackPage(): JSX.Element {
  const [errorText, setErrorText] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    async function completeAuth(): Promise<void> {
      try {
        if (process.env.NODE_ENV === "test") return;

        const supabase = await loadSupabaseClient();
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) {
            throw error;
          }
          window.location.assign("/");
          return;
        }

        const { data, error } = await supabase.auth.getSession();
        if (error) {
          throw error;
        }

        if (data?.session) {
          window.location.assign("/");
          return;
        }

        if (active) {
          setErrorText("No active session found. Please sign in again.");
        }
      } catch (error) {
        if (active) {
          setErrorText(error instanceof Error ? error.message : "Authentication callback failed");
        }
      }
    }

    void completeAuth();

    return () => {
      active = false;
    };
  }, []);

  return (
    <main style={{ margin: "0 auto", maxWidth: "30rem", padding: "var(--gutter)" }}>
      <h1 style={{ marginTop: 0 }}>Completing sign-in</h1>
      <p style={{ color: "var(--muted)" }}>Please wait while we verify your session…</p>
      {errorText ? (
        <p role="alert" style={{ color: "var(--danger-text)", marginTop: "1rem" }}>
          {errorText} <a href="/login">Go to login</a>
        </p>
      ) : null}
    </main>
  );
}
